var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667.833v2.5H0V.833A.836.836,0,0,1,.833,0h15A.836.836,0,0,1,16.667.833Z",
    transform: "translate(1.667 15)",
    fill: "#8963f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.833-.5h15A1.335,1.335,0,0,1,17.167.833v2.5a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V.833A1.335,1.335,0,0,1,.833-.5ZM16.167,2.833v-2A.338.338,0,0,0,15.833.5h-15A.338.338,0,0,0,.5.833v2Z",
    transform: "translate(1.667 15)",
    fill: "#8963f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.667V5.833H0Z",
    transform: "translate(4.167 9.167)",
    fill: "#8963f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.667V5.833H0Z",
    transform: "translate(7.5 9.167)",
    fill: "#8963f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.667V5.833H0Z",
    transform: "translate(10.833 9.167)",
    fill: "#8963f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.667V5.833H0Z",
    transform: "translate(14.167 9.167)",
    fill: "#8963f0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.958,1.25H.625A.63.63,0,0,1,0,.625.63.63,0,0,1,.625,0H18.958a.63.63,0,0,1,.625.625A.63.63,0,0,1,18.958,1.25Z",
    transform: "translate(0.208 17.708)",
    fill: "#8963f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.142,3.05l-7.5-3a.976.976,0,0,0-.617,0l-7.5,3A.892.892,0,0,0,0,3.825V6.592a.836.836,0,0,0,.833.833h15a.836.836,0,0,0,.833-.833V3.825A.892.892,0,0,0,16.142,3.05ZM8.333,5.342a1.25,1.25,0,1,1,1.25-1.25A1.248,1.248,0,0,1,8.333,5.342Z",
    transform: "translate(1.667 1.742)",
    fill: "#8963f0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank);
export default __webpack_public_path__ + "static/media/icon-bank.ed6ad033acf3a949f3470573c4fd2101.svg";
export { ForwardRef as ReactComponent };